import { render, staticRenderFns } from "./WebBottom.vue?vue&type=template&id=472035f0&scoped=true"
import script from "./WebBottom.vue?vue&type=script&lang=js"
export * from "./WebBottom.vue?vue&type=script&lang=js"
import style0 from "./WebBottom.vue?vue&type=style&index=0&id=472035f0&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472035f0",
  null
  
)

export default component.exports